import { render } from "./TopUp.vue?vue&type=template&id=02321720&scoped=true"
import script from "./TopUp.vue?vue&type=script&lang=js"
export * from "./TopUp.vue?vue&type=script&lang=js"

import "./TopUp.vue?vue&type=style&index=0&id=02321720&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02321720"]])

export default __exports__